import React, { useState } from 'react';
import { Star, MessageSquare, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { useReviews } from '@/store/dataStore';

function Stars({ value, onChange, size = 20 }) {
  return (
    <div className="flex gap-0.5">
      {[1,2,3,4,5].map((n) => (
        <button key={n} type="button" onClick={() => onChange && onChange(n)} className={onChange ? 'cursor-pointer' : 'cursor-default'}>
          <Star size={size} className={n <= value ? 'text-yellow-400' : 'text-slate-300'} fill={n <= value ? '#F8D13F' : 'none'} />
        </button>
      ))}
    </div>
  );
}

export default function ProductReviews({ productId, storeId = null, title = 'Opiniones' }) {
  const { forProduct, forStore, addReview } = useReviews();
  const list = productId ? forProduct(productId) : forStore(storeId);
  const [name, setName] = useState('');
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');

  const avg = list.length ? (list.reduce((s, r) => s + r.rating, 0) / list.length) : 0;

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim() || !comment.trim()) return;
    addReview({ productId: productId || null, storeId: storeId || null, name: name.trim(), rating, comment: comment.trim() });
    setName(''); setComment(''); setRating(5);
  };

  return (
    <div className="mt-8 border-t pt-6">
      <div className="flex items-center gap-3 mb-4">
        <h3 className="text-xl font-extrabold text-[#1B2A4A]">{title}</h3>
        {list.length > 0 && (
          <div className="flex items-center gap-2 text-sm">
            <Stars value={Math.round(avg)} size={16} />
            <span className="text-slate-600">({avg.toFixed(1)}) · {list.length} opinión{list.length !== 1 ? 'es' : ''}</span>
          </div>
        )}
      </div>

      <div className="space-y-3 mb-6">
        {list.length === 0 && <p className="text-sm text-slate-500 flex items-center gap-2"><MessageSquare size={16} /> Sé el primero en opinar.</p>}
        {list.map((r) => (
          <div key={r.id} className="bg-white border border-slate-200 rounded-lg p-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-[#F8D13F] text-[#1B2A4A] flex items-center justify-center text-xs font-bold">{r.name.charAt(0).toUpperCase()}</div>
                <div>
                  <div className="font-semibold text-sm text-[#1B2A4A]">{r.name}</div>
                  <div className="text-[11px] text-slate-400">{new Date(r.date).toLocaleDateString('es-VE')}</div>
                </div>
              </div>
              <Stars value={r.rating} size={14} />
            </div>
            <p className="text-sm text-slate-700 mt-2">{r.comment}</p>
          </div>
        ))}
      </div>

      <form onSubmit={submit} className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-3">
        <p className="font-bold text-sm text-[#1B2A4A]">Deja tu opinión</p>
        <div className="grid md:grid-cols-2 gap-3">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Tu nombre" required />
          <div className="flex items-center gap-2">
            <span className="text-xs text-slate-600">Calificación:</span>
            <Stars value={rating} onChange={setRating} />
          </div>
        </div>
        <Textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Cuéntanos tu experiencia..." rows={3} required />
        <Button type="submit" className="bg-[#1B2A4A] text-yellow-300 hover:bg-[#141f38] rounded-full">Publicar opinión</Button>
      </form>
    </div>
  );
}
